import React, { useState} from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';

const HeartbeatTable = ({ Record, heading }) => {
  console.log(`Record for ${heading}`, Record);

  const columns = [
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: "Current_DT", label: "Date", minWidth: 140 },
    { id: "api_name", label: "API Name", minWidth: 40 },
    { id: 'status_code', label: 'status Code', minWidth: 160 },
    { id: 'status_message', label: 'status Message', minWidth: 110 },
    { id: 'response_time', label: 'Response Time', minWidth: 110 },
    { id: 'additional_info', label: 'Additional Info', minWidth: 80 },
  ];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(100);


  // handleChangePage function to handle page changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex = newPage * rowsPerPage;
    console.log("startindex", startindex)
    let endindex = Math.min(startindex + rowsPerPage, Record.length)
    console.log("endindex", endindex)
    setStartIndex(startindex);
    setEndIndex(endindex)

  };

  // handleChangeRowsPerPage function to handle rows per page changes
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };

  // formatDateTime function to format date and time
  const formatDateTime = (row) => {
    // Assuming row.Current_DT is in UTC and in a format recognized by new Date()
    let date = new Date(row.Current_DT);

    // Convert to IST using toLocaleString
    let istDateStr = date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });

    // Now, parse this date string back to a Date object to extract parts
    let istDate = new Date(istDateStr);

    // Format the IST date parts
    const day = String(istDate.getDate()).padStart(2, '0');
    const month = String(istDate.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-indexed
    const year = istDate.getFullYear();
    const hours = String(istDate.getHours()).padStart(2, '0');
    const minutes = String(istDate.getMinutes()).padStart(2, '0');

    // Construct the formatted date string in IST
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
    return formattedDate;
}




  return (
    <div className='mcxtable'>

      <h5 style={{width:'100%', textAlign:'center', marginTop:'20px',fontSize: "24px"}} >{heading}</h5>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
            <TableHead >
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                    //   textAlign: 'center',
                      minWidth: column.minWidth,
                      backgroundColor: '#23499E',
                      color: 'white',
                   
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Record
                .slice(startIndex, endIndex)
                .map((row, index) => {
              
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              position: 'sticky',
                          }}
                            class="table-cell-screenerTab"
                            key={column.id}
                            align={column.align}
                          >
                            {column.id === "S.No"
                              ? index + 1
                              : column.id === "Current_DT"
                                    ? formatDateTime(row)
                                    : value
                            }
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={Record.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  )
}

export default HeartbeatTable